import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import ku from "./locales/ku.json";
import { sectionTranslations } from "./locales/sectionI18n";
import {
  getLanguageFromPathname,
  normalizeLanguage,
} from "./utils/languageRouting";

const rtlLanguages = ["ku", "ar"];

const getInitialLanguage = () => {
  if (typeof window !== "undefined") {
    const fromPath = getLanguageFromPathname(window.location.pathname);
    if (fromPath) return fromPath;
    try {
      const saved = localStorage.getItem("irqgyp_lang");
      if (saved) return normalizeLanguage(saved);
    } catch {
      // ignore
    }
  }
  return "en";
};

const savedLang = getInitialLanguage();

export const isDashboardRoute = () =>
  typeof window !== "undefined" && window.location.pathname.startsWith("/dashboard");

export const setDirection = (lang) => {
  const normalizedLang = String(lang || "en").toLowerCase().split("-")[0];
  const isRTL = !isDashboardRoute() && rtlLanguages.includes(normalizedLang);

  document.documentElement.dir = isRTL ? "rtl" : "ltr";
  document.documentElement.lang = normalizedLang;
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: { ...en, sections: sectionTranslations.en } },
    ar: { translation: { ...ar, sections: sectionTranslations.ar } },
    ku: { translation: { ...ku, sections: sectionTranslations.ku } },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// set initial direction
setDirection(savedLang);

// listen for language changes
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("irqgyp_lang", lng);
  setDirection(lng);
});

export default i18n;
